module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view),
      expression: "view"
    }],
    staticClass: "notification",
    class: _vm.message.classes
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.message.text)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24fcc676","hasScoped":false}!./src/components/message-system/template.html
// module id = 402
// module chunks = 1